import { requestApi } from "@/api/core";
import { dynamicDispatcher } from "@/libs/util";

export const projectPreShare = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Project/PreShare",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};

export const getInheritedDetail = ({ data, params, store }) => {
  return new Promise(resolve => {
    requestApi({
      api: "Project/GetInheritedDetail",
      method: "get",
      params: params,
      data: data
    }).then(res => {
      if (res != false) {
        let rs = dynamicDispatcher(res, store);
        if (rs != false) {
          resolve(rs);
        } else {
          resolve(false);
        }
      } else {
        resolve(false);
      }
    });
  });
};
